import ROUTE_NAME from '../../router/names';

const guest = [
    {
        title: '进入游客端',
        icon: '&#xe670;',
        _blank: true,
        route_name: ROUTE_NAME.GUEST.SEARCH,
        children: []
    },
    {
        title: '使用帮助',
        icon: '&#xe651;',
        _blank: true,
        native: true,
        url: '//robo-static.oss-cn-qingdao.aliyuncs.com/doc/help-enrollment.pdf',
        children: []
    },
    {
        title: 'FAQ',
        icon: '&#xe651;',
        _blank: true,
        native: true,
        url: 'https://docs.qq.com/doc/DSllRY1pHRHl6aW5V',
        children: []
    },

    {
        title: '证书',
        icon: '&#9672;',
        route_name: ROUTE_NAME.GUEST.CERTIFICATE,
        children: [
            {
                title: '证书验证',
                route_name: ROUTE_NAME.GUEST.CERTIFICATE
            }
        ]
    },
    {
        title: '参赛查询',
        icon: '&#10047;',
        route_name: ROUTE_NAME.GUEST.COMPETITION,
        children: [
            {
                title: '参赛查询',
                route_name: ROUTE_NAME.GUEST.COMPETITION
            }
        ]
    }
];

export default guest;
